export interface HeaderTextProps {
  text: string;
}

const HeaderText = (props: HeaderTextProps) => {
  return <p className="text-2xl text-text font-semibold">{props.text}</p>;
};

export default HeaderText;
